import { ListsOverview } from '../components/lists-overview';

export const ListsPage = () => {
  return (
    <div className="flex h-full min-h-0 w-full max-w-[1400px] flex-col">
      <ListsOverview />
    </div>
  );
};
